import {Injectable, OnDestroy} from '@angular/core';
import {CategoriesServiceClient} from "./institution-categories-client.service";
import {
  BehaviorSubject,
  combineLatest,
  Observable,
  Subject
} from "rxjs";
import {map} from "rxjs/operators";
import {CategoriaServizio} from "../../../models/personal-area/institutiton-categories/categoria-servizio.model";
import {StoreService} from "../../store.service";

export const disableSearchButton = (searchTerm: string) => searchTerm.length < 3

@Injectable({providedIn: "root"})
export class InstitutionCategoriesService implements OnDestroy {

  public categoriesService = new BehaviorSubject<{
    codiceIpaEnte:string;
    categorieServizi: CategoriaServizio[];
  }>({
    codiceIpaEnte: "",
    categorieServizi: []
  });
  private searchTerm = new BehaviorSubject<string>("");
  private searchTermForSelectedCategory = new BehaviorSubject<string>("");
  private categoryLabel = new BehaviorSubject<string>("");

  public noResultsFound: boolean = true
  /**
   * l'idempotenza dei poveri
   */
  public codiceIpa: string | undefined
  public readonly disableSearchButton = disableSearchButton;

  public categoriesService$ = this.categoriesService.pipe(map(s =>s.categorieServizi));
  public readonly compareTerms = (s: string, term: string) => s.toLocaleLowerCase().includes(term.toLocaleLowerCase());

  public categoriesServiceBySearchTerm$: Observable<CategoriaServizio[]> = combineLatest([
    this.categoriesService,
    this.searchTerm
  ]).pipe(
    map(([categoriesService, searchTerm]) => {
      if (this.disableSearchButton(searchTerm)) {
        return [];
      }
      const filteredCategories = categoriesService.categorieServizi
        .map((cats: any) => ({
          ...cats,
          servizi: cats.servizi.filter((s: any) => this.compareTerms(s.descrizioneServizio, searchTerm))
        }))
        .filter((cats: any) => cats.servizi.length > 0);

      this.noResultsFound = filteredCategories.length === 0; // Aggiorna la variabile noResultsFound

      return filteredCategories;
    })
  );

  public selectedCategory$: Observable<CategoriaServizio | undefined> = combineLatest([
    this.categoriesService,
    this.categoryLabel
  ]).pipe(
    map(([categoriesServices, categoryLabel]) => categoryLabel !== "" ?
      categoriesServices.categorieServizi.find(cats => cats.labelCategoria === categoryLabel) :
      undefined)
  );

  public filteredServicesByCategoryLabel$ = combineLatest([
    this.selectedCategory$,
    this.searchTermForSelectedCategory,
  ]).pipe(
    map(([cat, terms]) =>
      cat?.servizi?.filter(s => this.compareTerms(s.descrizioneServizio, terms)) ?? []
    )
  )

  private onDestroy$ = new Subject<boolean>();

  constructor(
    private client: CategoriesServiceClient,
    private storeService: StoreService
  ) {
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  setSearchTerm(value: string) {
    this.searchTerm.next(value);
  }

  getServiziSpontanei(codiceIpa: string) {
    const categoriesService = this.categoriesService.getValue()
    if (this.storeService.codIpa !== codiceIpa.toUpperCase() || categoriesService.codiceIpaEnte !== codiceIpa || categoriesService.categorieServizi.length === 0) {
      this.client.get$(codiceIpa).subscribe((data) => {
        this.categoriesService.next(data.result)
      });
    }
  }

  getCategories() {
    return this.categoriesService.getValue().categorieServizi
  }

  setSelectedCategory(categoryLabel: string) {
    this.categoryLabel.next(categoryLabel);
  }

  setSearchTermForSelectedCategory(searchTerms: string) {
    if (searchTerms.length >= 3 || searchTerms.length === 0) {
      this.searchTermForSelectedCategory.next(searchTerms)
    }
  }
}
